/**
 * Lazy-loaded route components for code splitting
 * Import this file to use lazy-loaded pages
 */

import { lazy } from 'react';

// Public pages
export const LazyHomePage = lazy(() => import('./pages/HomePage'));
export const LazyExperts = lazy(() => import('./pages/Experts'));

export const LazyExplore = lazy(() => import('./pages/Explore'));
export const LazyHelpCenter = lazy(() => import('./pages/HelpCenter'));

// Auth & Chat
export const LazyAuth = lazy(() => import('./pages/Auth'));
export const LazyTaxOracleChatArea = lazy(() => import('./components/tax-oracle/TaxOracleChatArea').then(m => ({ default: m.TaxOracleChatArea })));

// Expert pages
export const LazyExpertProfile = lazy(() => import('./pages/ExpertProfile'));
export const LazyUserRegister = lazy(() => import('./pages/UserRegister'));


// Account pages
export const LazyAccountProfile = lazy(() => import('./pages/account/MyAccount'));
export const LazyAccountSettings = lazy(() => import('./pages/account/AccountSettings'));
export const LazyAccountOverview = lazy(() => import('./pages/account/Overview'));
export const LazyAccountPerformance = lazy(() => import('./pages/account/Performance'));
export const LazyOpportunities = lazy(() => import('./pages/account/Opportunities'));

export const LazyMembershipOverview = lazy(() => import('./pages/account/MembershipOverview'));
export const LazyMembershipOrders = lazy(() => import('./pages/account/MembershipOrders'));
export const LazyMembershipMethods = lazy(() => import('./pages/account/MembershipMethods'));

export const LazyAccountPublications = lazy(() => import('./pages/account/Publications'));
export const LazyPublicationEditor = lazy(() => import('./pages/account/PublicationEditor'));
export const LazyAccountChats = lazy(() => import('./pages/account/AccountChats'));
export const LazyAccountChatProjects = lazy(() => import('./pages/account/AccountChatProjects'));

// Admin pages
export const LazyAdminDashboard = lazy(() => import('./pages/AdminOperations'));
export const LazyAdminActivity = lazy(() => import('./pages/AdminActivity'));

export const LazyAdminOpportunities = lazy(() => import('./pages/AdminOpportunities'));

export const LazyAdminRoles = lazy(() => import('./pages/admin/AdminRoles'));
export const LazyAdminManagement = lazy(() => import('./pages/AdminManagement'));


export const LazyAdminPageEditor = lazy(() => import('./pages/admin/PageEditor'));
export const LazySystemEntityEditor = lazy(() => import('./pages/admin/SystemEntityEditor'));
export const LazyTopicEditor = lazy(() => import('./pages/admin/TopicEditor'));
export const LazyComments = lazy(() => import('./pages/account/Comments'));
export const LazyMedia = lazy(() => import('./pages/account/Media'));
export const LazyAdminIntelligence = lazy(() => import('./pages/admin/AdminIntelligence'));
export const LazyDesignSystem = lazy(() => import('./pages/admin/DesignSystem'));
// QAFixCenter is now embedded in AdminManagement under Localization > QA tab



// Topic pages
export const LazyTopicPage = lazy(() => import('./pages/TopicPage'));
export const LazyTopicsListing = lazy(() => import('./pages/TopicsListing'));

// Billing pages
export const LazyPlansPage = lazy(() => import('./pages/public/PlansPage'));
export const LazyCheckoutPage = lazy(() => import('./pages/public/CheckoutPage'));
export const LazyCheckoutConfirmation = lazy(() => import('./pages/public/CheckoutConfirmation'));


// Other
export const LazyResetPassword = lazy(() => import('./pages/ResetPasswordPage'));
export const LazyVerifyOpportunityEmail = lazy(() => import('./pages/VerifyOpportunityEmail'));
export const LazyFavorites = lazy(() => import('./pages/Favorites'));
export const LazyOAuthCallback = lazy(() => import('./pages/auth/OAuthCallback'));
// Deterministic Routers (Phase 4: Manifest-based routing)
// NOTE: Legacy resolvers (LocalizedPageResolver, TwoSegmentResolver) have been deleted.
// See docs/ROUTING_CONTRACT.md for the binding architectural contract.
export const LazyDeterministicRouter = lazy(() => import('./lib/routing/DeterministicRouter').then(m => ({ default: m.DeterministicRouter })));
export const LazyTwoSegmentDeterministicRouter = lazy(() => import('./lib/routing/TwoSegmentDeterministicRouter').then(m => ({ default: m.TwoSegmentDeterministicRouter })));

// 404 page
export const LazyNotFound = lazy(() => import('./pages/NotFound'));
